/* unplugin-vue-components disabled */import { render } from "./Truck.vue?vue&type=template&id=328b358d"
import script from "./Truck.vue?vue&type=script&lang=js"
export * from "./Truck.vue?vue&type=script&lang=js"

import "./Truck.vue?vue&type=style&index=0&id=328b358d&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__